import Routes from '../views'

export const AppNavigation = () => (
  <>
    <Routes />
  </>
)
